<div class="sla-container">
  <div class="sla-header">
    <div>
      <h2><i class="fa-solid fa-route"></i> Assignment Rules</h2>
      <p class="sla-sub">Routing rules evaluated in Priority order when a ticket is created. The first matching rule(s) can set the ticket's priority and pick a team; the org's Auto-Assign Mode then assigns a member within that team.</p>
    </div>
    <button class="btn-primary" (click)="startCreate()" *ngIf="!isCreating">
      <i class="fa-solid fa-plus"></i> New Rule
    </button>
  </div>

  <div class="banner banner-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="banner banner-success" *ngIf="successMessage">{{ successMessage }}</div>

  <!-- Create -->
  <div class="policy-card editing" *ngIf="isCreating">
    <div class="form-grid">
      <label>Name<input type="text" [(ngModel)]="createForm.name" placeholder="e.g. Billing Routing" /></label>
      <label>Eval priority<input type="number" [(ngModel)]="createForm.priority" title="Lower runs first" /></label>
      <label class="checkbox-field">
        <input type="checkbox" [(ngModel)]="createForm.isActive" />
        Active
      </label>
      <label class="full-row">Description<input type="text" [(ngModel)]="createForm.description" placeholder="Optional" /></label>
    </div>

    <ng-container *ngTemplateOutlet="conditionBuilder; context: { form: createForm }"></ng-container>
    <ng-container *ngTemplateOutlet="actionBuilder; context: { form: createForm }"></ng-container>

    <div class="form-actions">
      <button class="btn-primary" (click)="saveCreate()" [disabled]="isSaving">Create</button>
      <button class="btn-ghost" (click)="cancelCreate()">Cancel</button>
    </div>
  </div>

  <div class="sla-loading" *ngIf="isLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading rules…</div>

  <div class="sla-empty" *ngIf="!isLoading && rules.length === 0 && !isCreating">
    <i class="fa-solid fa-route"></i>
    <p>No assignment rules yet. Create one to route tickets to teams and set priorities automatically.</p>
  </div>

  <!-- Rule list -->
  <div class="policy-card" [class.editing]="d.isEditing" *ngFor="let d of rules">
    <!-- Read row -->
    <div class="policy-row" *ngIf="!d.isEditing">
      <div class="policy-main">
        <span class="policy-name">{{ d.rule.Name }}</span>
        <span class="policy-meta">
          <span class="metric"><i class="fa-solid fa-list-ol"></i> Priority {{ d.rule.Priority }}</span>
          <span class="metric"><i class="fa-solid fa-bolt"></i> {{ actionsSummary(d) }}</span>
        </span>
      </div>
      <span class="status-chip" [class.inactive]="!d.rule.IsActive">{{ d.rule.IsActive ? 'Active' : 'Inactive' }}</span>
      <div class="policy-actions">
        <button class="icon-btn" title="Edit" (click)="startEdit(d)"><i class="fa-solid fa-pen"></i></button>
        <button class="icon-btn danger" title="Delete" (click)="confirmDelete(d)"><i class="fa-solid fa-trash"></i></button>
      </div>
    </div>

    <!-- Edit form -->
    <div *ngIf="d.isEditing">
      <div class="form-grid">
        <label>Name<input type="text" [(ngModel)]="d.form.name" /></label>
        <label>Eval priority<input type="number" [(ngModel)]="d.form.priority" title="Lower runs first" /></label>
        <label class="checkbox-field">
          <input type="checkbox" [(ngModel)]="d.form.isActive" />
          Active
        </label>
        <label class="full-row">Description<input type="text" [(ngModel)]="d.form.description" placeholder="Optional" /></label>
      </div>

      <ng-container *ngTemplateOutlet="conditionBuilder; context: { form: d.form }"></ng-container>
      <ng-container *ngTemplateOutlet="actionBuilder; context: { form: d.form }"></ng-container>

      <div class="form-actions">
        <button class="btn-primary" (click)="saveEdit(d)" [disabled]="isSaving">Save</button>
        <button class="btn-ghost" (click)="cancelEdit(d)">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- ===== shared condition builder ===== -->
<ng-template #conditionBuilder let-form="form">
  <div class="rule-section">
    <div class="rule-section-head">
      <span class="rule-section-title">Conditions</span>
      <label class="inline-select">Match
        <select [(ngModel)]="form.operator">
          <option value="AND">ALL of</option>
          <option value="OR">ANY of</option>
        </select>
      </label>
    </div>
    <div class="condition-row" *ngFor="let c of form.conditions; let i = index">
      <select [(ngModel)]="c.field">
        <option *ngFor="let f of fields" [value]="f.value">{{ f.label }}</option>
      </select>
      <select [(ngModel)]="c.op">
        <option *ngFor="let o of ops" [value]="o.value">{{ o.label }}</option>
      </select>
      <input type="text" [(ngModel)]="c.value" placeholder="value" />
      <button class="icon-btn danger" title="Remove" (click)="removeCondition(form, i)"><i class="fa-solid fa-xmark"></i></button>
    </div>
    <button class="btn-ghost btn-sm" (click)="addCondition(form)"><i class="fa-solid fa-plus"></i> Add condition</button>
  </div>
</ng-template>

<!-- ===== shared action builder ===== -->
<ng-template #actionBuilder let-form="form">
  <div class="rule-section">
    <div class="rule-section-head"><span class="rule-section-title">Actions</span></div>
    <div class="form-grid">
      <label>Assign team
        <select [(ngModel)]="form.assignTeamId">
          <option value="">— No team —</option>
          <option *ngFor="let t of teams" [value]="t.ID">{{ t.Name }}</option>
        </select>
      </label>
      <label>Set priority
        <select [(ngModel)]="form.setPriority">
          <option value="">— Leave unchanged —</option>
          <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
        </select>
      </label>
    </div>
  </div>
</ng-template>
